import React, { useEffect, useState } from "react";
import TvSchedule from "./TvSchedule";
import MatchVenue from "./MatchVenue";
import EventTable from "./EventTable";
import { loadStyles } from "../../../utils/cssLoader";

const InfoTable = ({ data, loadCSS, dataClient, matchDetail, title }) => {
  const [tvScheduleData, setTvScheduleData] = useState(null);
  const [venueData, setVenueData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    if (!container) return;

    const raw = container.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw);
      setTvScheduleData(parsed?.data || {});
      setVenueData(parsed?.headData?.data || {});
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("matchinfo");
    }
  }, [loadCSS]);

  const tvDataToShow = dataClient
    ? tvScheduleData?.tv_schedule
    : data?.tv_schedule;
  const venueToShow = dataClient ? venueData?.venue : matchDetail?.data?.venue;
  const summaryData = dataClient
    ? tvScheduleData?.summary?.timeline
    : data?.timeline;
  const hasTvSchedule =
    tvDataToShow && Object.keys(tvDataToShow)?.length > 0;
  // const shouldShowEventTable =
  //   matchStatus === typesMatchStatus?.finished ||
  //   matchStatus === typesMatchStatus?.finishedAET;
  return (
    <>
      {title && <h1>{title}</h1>}
      {summaryData?.length ? <EventTable data={summaryData || []} /> : null}
      {hasTvSchedule ? <TvSchedule data={tvDataToShow || []} /> : null}
      <MatchVenue venue={venueToShow || {}} />
    </>
  );
};

export default InfoTable;
